import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SigninWrapper from "../../components/wrapper/SigninWrapper";
import Button from "../../components/button/Button";
import InputField from "../../components/Form/InputField";
import { useFormik } from "formik";
import { loginSchema } from "../../schema";
import ButtonLoader from "../../components/button/ButtonLoader";
import { SigninAPI } from "../../API/auth/SigninAction";
import { useDispatch } from "react-redux";

const initialValue = {
  email: "",
  password: "",
};
const Signin = () => {
  const [btnLoader, setBtnLoader] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { errors, touched, values, handleBlur, handleSubmit, handleChange } =
    useFormik({
      initialValues: initialValue,
      validationSchema: loginSchema,
      onSubmit: async (values) => {
        setBtnLoader(true);
        dispatch(SigninAPI(values))
          .then(() => {
            navigate("/");
            setBtnLoader(false);
          })
          .catch((error) => {
            console.log(error);
            setBtnLoader(false);
          });
      },
    });

  return (
    <>
      <SigninWrapper headingText={" Sign in to your account "}>
        <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
          <InputField
            label={"Your email"}
            id={"email"}
            name={"email"}
            type={"text"}
            placeholder={"name@company.com"}
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.email}
            touch={touched.email}
          />
          <InputField
            label={"New Password"}
            id={"password"}
            name={"password"}
            type={"password"}
            placeholder={"••••••••"}
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors.password}
            touch={touched.password}
          />
          <div className="flex items-center justify-end w-full">
            <Link
              to={"/forgetPassword"}
              className="text-sm font-medium text-primary-600 hover:underline "
            >
              Forgot password?
            </Link>
          </div>
          {btnLoader ? (
            <div className="mt-5 w-full flex justify-center items-center">
              <ButtonLoader />
            </div>
          ) : (
            <div className="flex justify-center">
              <Button type={"submit"} text={"LOGIN"} />
            </div>
          )}
        </form>
      </SigninWrapper>
    </>
  );
};

export default Signin;
